import { render, staticRenderFns } from "./RadioButtonIcon.vue?vue&type=template&id=27d53a01&"
import script from "./RadioButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports